export default "__VITE_ASSET__e92e169a__"